import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 6a7 3 0 1 0 14 0a7 3 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M5 6v12c0 1.657 3.134 3 7 3s7 -1.343 7 -3v-12","key":"svg-1"}]]

const IconCylinder = createReactComponent('outline', 'cylinder', 'Cylinder', __iconNode);

export default IconCylinder;